import { object, string } from "yup";

import { TheftOrVandalism } from "@api/operations.generated";
import { nonEmptyString } from "@covertree/utils";

import {
  InjuredPeopleFormPart,
  injuredPeopleValidation,
} from "../shared/InjuredPersonsSection/form";

export interface TheftOrVandalismFormPart {
  claimType: TheftOrVandalism;
  claimDescription: string;
}

export type TheftOrVandalismForm = TheftOrVandalismFormPart &
  InjuredPeopleFormPart;

export const validation = object({
  claimType: string().required("Claim type is required"),
  claimDescription: nonEmptyString("Claim description").max(
    3000,
    "Claim description is too long"
  ),
  ...injuredPeopleValidation,
});
